import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import theme from '../../assets/styles/theme';

const ToastBody = styled.div`
  display: flex;
  align-items: center;

  .toast-body__text {
    margin-left: ${theme.spacing['spacing-6']};
  }
`;

const IconCloseWrapper = styled.div`
  align-self: flex-start;
`;

const Toast = styled(ToastContainer)`
  .Toastify__toast-body {
    width: 100%;
  }

  &.Toast__toast-body--md-full {
    width: 100%;
  }
  &.Toastify__toast-container {
    z-index: 9999;
    position: fixed;
  }
  .Toastify__toast {
    width: 328px;
    display: flex;
    justify-content: space-between;
    border-radius: ${theme.borderRadius['border-radius-2']};
    margin: ${theme.spacing['spacing-4']};
    padding: ${theme.spacing['spacing-6']} ${theme.spacing['spacing-5']};
  }

  &.Toastify__toast-container--top-right {
    top: 0;
    right: 0;
  }

  &.Toastify__toast-container--top-left {
    top: 0;
    left: 0;
  }
  &.Toastify__toast-container--top-center {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  &.Toastify__toast-container--bottom-left {
    bottom: 0;
    left: 0;
  }
  &.Toastify__toast-container--bottom-center {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  &.Toastify__toast-container--bottom-right {
    bottom: 0;
    right: 0;
  }
  .Toastify__toast--success {
    background: ${theme.colors.success.bg.regular};
  }
  .Toastify__toast--error {
    background: ${theme.colors.danger.bg.regular};
  }
  .Toastify__toast--info {
    background: ${theme.colors.info.bg.regular};
  }
  .Toastify__toast--warning {
    background: ${theme.colors.warning.bg.regular};
  }
  @keyframes Toastify__fadeIn {
    from {
      opacity: ${theme.opacities['opacity-4']};
    }
    to {
      opacity: ${theme.opacities['opacity-1']};
    }
  }
  @keyframes Toastify__fadeOut {
    from {
      opacity: ${theme.opacities['opacity-1']};
    }
    to {
      opacity: ${theme.opacities['opacity-4']};
    }
  }
  .Toastify__fade-enter {
    animation-name: Toastify__fadeIn;
  }

  .Toastify__fade-exit {
    animation-name: Toastify__fadeOut;
  }
  @keyframes Toastify__trackProgress {
    0% {
      transform: scaleX(1);
    }
    100% {
      transform: scaleX(0);
    }
  }
  .Toastify__progress-bar--animated {
    animation: Toastify__trackProgress linear 1 forwards;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  margin-left: ${theme.spacing['spacing-6']};

  &:focus,
  &:focus-visible {
    outline: none;
  }
  outline: none;

  &::-moz-focus-inner {
    border: none;
  }
  border: none;

  border-radius: ${theme.borderRadius['border-radius-5']};
  ${theme.textStyles['text-preset-7']};

  ${(props) =>
    (props.color === 'light' &&
      `
      &, &:hover, &:active {
        color: ${theme.colors['neutral'].text.inverted};
      }
    `) ||
    (props.color === 'dark' &&
      `
      &, &:hover, &:active {
        color: ${theme.colors['neutral'].text.strong};
      }
    `)}
`;

export { ToastBody, Toast, IconCloseWrapper, Button };
